import css from "./regular-button.module.css";
export const levelCss = {
    primary: css.primary,
    secondary: css.secondary,
};
export const buttonStyleCss = {
    regular: '',
    discount: css.discount,
    destructive: css.destructive,
    neutral: css.neutral,
};
export const sizeCss = {
    regular: '',
    small: css.small,
};
export const spinnerSize = {
    regular: 24,
    small: 16,
};
